const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M1.328 24C1.04 24 0.8 23.896 0.608 23.688C0.416 23.48 0.32 23.24 0.32 22.968C0.32 22.872 0.328 22.8 0.344 22.752C0.376 22.624 1.672 18.896 4.232 11.568C6.792 4.24 8.088 0.552 8.12 0.503999C8.296 0.167999 8.584 -1.43051e-06 8.984 -1.43051e-06C9.336 -1.43051e-06 9.616 0.143999 9.824 0.431999C9.856 0.495999 10.52 2.376 11.816 6.072C13.112 9.752 14.4 13.44 15.68 17.136L17.6 22.656C17.632 22.816 17.648 22.928 17.648 22.992C17.648 23.264 17.552 23.496 17.36 23.688C17.168 23.896 16.936 24 16.664 24C16.328 24 16.04 23.848 15.8 23.544L8.984 4.104C4.536 16.952 2.264 23.432 2.168 23.544C1.928 23.848 1.648 24 1.328 24Z",
  fill: "#1E3F6B"
});

const SvgEquationIntegrals8 = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 24,
    viewBox: "0 0 18 24",
    fill: "none",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEquationIntegrals8, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/equation-integrals-8.4aa56c9f.svg";
export { ForwardRef as ReactComponent };